import { all, call, put, takeEvery } from 'redux-saga/effects'
import actions from './actions'
import { tryApiCall } from '../../utilities/sagas'
import api from '../../api'


function* onInitialize() {
  try {

    const [rspTopics, rspSchools] = yield all([
      call(tryApiCall, 'topics', [], call([api.topic, 'list'])),
      call(tryApiCall, 'schools', [], call([api.school, 'list'])),
    ])

    // console.log("Got " + rspTopics.length + " topics")
    // console.log("Got " + rspSchools.length + " topics")

    yield put(
      actions.set({
        initialized: true,
        topics: rspTopics,
        schools: rspSchools,
      }),
    )

  } catch (e) {
    console.error('Failed to get topics & schools', e)
  }
}

export default function* () {
  yield all([
      takeEvery(actions.initialize.toString(), onInitialize),
    ],
  )
}




// WEBPACK FOOTER //
// ../source/views/ActivitiesAndSchools/sagas.js